import { FC, useEffect, useMemo } from 'react';
import { format } from 'date-fns';

import { WerklijnContextMenuDetails } from '@/components/contextMenu/mwdContextMenu/types';
import { useKnippenDialog } from '@/components/dialogs/knippen/useKnippenDialog';
import MwdDialog from '@/components/UI/Dialog/Dialog';
import { SelectField } from '@/components/UI/Fields/ReactFormFields/SelectField';
import { Label } from '@/components/UI/Label/Label';
import { gefilteredActiviteiten } from '@/utils/helpers';

import styles from '@/components/UI/Dialog/Dialog.module.css';

type KnippenDialogProps = {
  showDialog: boolean;
  handleOpenChange: (p: boolean) => void;
  details: WerklijnContextMenuDetails;
};

const KnippenDialog: FC<KnippenDialogProps> = ({ showDialog, handleOpenChange, details }) => {
  const {
    resetDialog,
    onSubmit,
    handleSubmit,
    clearErrors,
    setValue,
    control,
    fetchActiviteitenVoorBewegingData,
    activiteitenVoorBewegingData,
    warningMessage,
  } = useKnippenDialog(details, handleOpenChange);

  useEffect(() => {
    clearErrors();
    setValue('knipActiviteit', undefined);
    if (showDialog) {
      fetchActiviteitenVoorBewegingData(`/bewegingen/activiteiten/${details?.treinnummer}/${details?.treindatum}`);
    }
  }, [showDialog, details]);

  const activiteitenOptions = useMemo(() => {
    if (activiteitenVoorBewegingData !== null && activiteitenVoorBewegingData !== undefined) {
      return gefilteredActiviteiten(activiteitenVoorBewegingData, details).map((item) => {
        const itemDienstregelpunt = item?.dienstregelpunt ? `${item.dienstregelpunt} ` : '';
        return {
          value: item,
          label: `${itemDienstregelpunt}(${item?.soort?.[0]}: ${format(new Date(item?.actueelGeplandeTijd), 'HH:mm')})`,
        };
      });
    }
  }, [activiteitenVoorBewegingData]);

  return (
    <MwdDialog
      title='Knippen'
      className={styles.knippenDialogStyle}
      showDialog={showDialog}
      handleOpenChange={handleOpenChange}
      data-testid={`contextMenu-knippen-${details?.treinnummer}`}
      hasCloseInHeader={true}
      showNotification={warningMessage}
      notificationType='warning'
      notificationText='Let op: de werklijnversie is gewijzigd'
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <div>
          <Label>Treinnummer</Label>
          <div style={{ color: 'var(--tractie-color-content-default)', marginBottom: '14px' }}>
            {details.treinnummer}
          </div>
          <div
            style={{
              height: '2px',
              marginBottom: '8px',
              marginTop: '8px',
              width: '306px',
              background: 'var(--tractie-color-border-subtle)',
            }}
          />
        </div>

        <div style={{ display: 'flex', gap: '12px' }}>
          <SelectField
            minWidth='306px'
            placeholder='Zoek op dienstregelpunt'
            control={control}
            testId='activiteit-select'
            required
            name='knipActiviteit'
            label='Dienstregelpunt'
            options={activiteitenOptions}
          />
        </div>
        <MwdDialog.Footer submitCaption='Knip inzet' cancelCallback={() => resetDialog(true)} />
      </form>
    </MwdDialog>
  );
};

export default KnippenDialog;
